<template>
  <SignInSignUpLayout>
    <b-form class="sing-in-form" @submit="passwordReset">
      <h1 class="sign-in-title">Reset password</h1>

      <fragment v-if="!ui.formSubmittedSuccessful">
        <b-form-group :state="emailState">
          <label class="form__label input-label" for="email-input">Email</label>
          <b-form-input
            id="email-input"
            v-model="email"
            :state="emailState"
            placeholder="Your email"
            autocomplete="username"
            class="sing-up-input"
          />
          <template v-slot:invalid-feedback>
            <div v-for="(error, index) in emailErrorMessage" :key="index">
              {{ error }}
            </div>
          </template>
        </b-form-group>

        <b-button class="button submit-button" type="submit" variant="primary" :disabled="isSubmitButtonDisabled">
          Reset password
        </b-button>

        <div class="or-sign-in">
          or
          <router-link
            :to="{name: ROUTES.SIGN_IN.name}"
            class="link"
          >
            Sign in
          </router-link>
        </div>
      </fragment>

      <div v-else class="success-message">
        Instructions to reset your password have been sent to your email address.<br>
        Please check your inbox and follow the steps provided.
      </div>
    </b-form>
  </SignInSignUpLayout>
</template>

<script>
import SignInSignUpLayout from '@components/sign-up/SignInSignUpLayout.vue'
import { validationMixin } from 'vuelidate'
import { email, required } from 'vuelidate/lib/validators'

export default {
  name: 'PasswordReset',
  mixins: [ validationMixin ],
  components: { SignInSignUpLayout },
  data () {
    return {
      email: '',
      emailServerErrors: null,

      submitButtonPressed: false,
      ui: {
        resetRequestPending: false,
        formSubmittedSuccessful: null
      }
    }
  },
  validations: {
    email: {
      required,
      email
    }
  },
  computed: {
    emailState () {
      return this.submitButtonPressed && this.emailErrorMessage ? false : null
    },
    emailErrorMessage () {
      if (this.emailServerErrors) {
        return this.emailServerErrors
      }

      if (!this.$v.email.required) {
        return [this.VALIDATION_MESSAGES.common.required]
      }

      if (!this.$v.email.email) {
        return [this.VALIDATION_MESSAGES.email.invalid]
      }

      return null
    },
    isSubmitButtonDisabled () {
      return this.ui.resetRequestPending || (this.submitButtonPressed && this.$v.$invalid)
    }
  },
  methods: {
    passwordReset (e) {
      e.preventDefault()

      this.submitButtonPressed = true
      this.emailServerErrors = null

      if (this.$v.$invalid) {
        return
      }

      this.ui.resetRequestPending = true

      this.axios
        .post('/api/password/reset', {
          email: this.email
        })
        .then(() => {
          this.ui.formSubmittedSuccessful = true
        })
        .catch(error => {
          if (error.response?.data?.errors) {
            const { email, ...restErrors } = error.response.data.errors

            if (email) this.emailServerErrors = email

            const errors = Object.values(restErrors)

            for (let i = 0; i < errors.length; i++) {
              this.$snotify.error(errors[i][0], 'Error', this.$store.state.snotify)
            }
          } else {
            this.$snotify.error(error.response?.data?.error ?? error, 'Error', this.$store.state.snotify)
          }
        })
        .finally(() => {
          this.ui.resetRequestPending = false
        })
    }

  }
}
</script>

<style lang="scss" scoped>
button.submit-button {
  margin-top: 0;
}

.success-message {
  width: 68%;
  margin: 0 auto;
  text-align: center;
}

.or-sign-in {
  margin-top: 1rem;
  text-align: center;
  font-size: 18px;
  font-weight: 500;

  .link {
    font-size: 18px;
  }
}
</style>
